(() => {
  // app/scripts/distributor-page.js
  $(".mapHilight").maphilight({
    fillColor: "E8412C",
    fillOpacity: 1,
    stroke: true,
    strokeColor: "E8412C",
    fade: false
  });
  $("#map > area").hover(function() {
    var selector = $(this).data("target");
    $(".mapHilight-container .hover").removeClass("hover");
    $(selector).addClass("hover");
    if (selector.includes("NSW") && $(".navACT").length) {
      $(".navACT").addClass("hover");
    }
  }, function() {
    $(".mapHilight-container .hover").removeClass("hover");
  });
})();
